import React from 'react';
import { styles } from './TextLine.css';
import { Base, LoadingSkeletonProps } from '../../Base/Base';
import { Shimmer } from '../../Shimmer/Shimmer';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

export const TextLine = ({
  shouldShimmer,
  height = '10px',
  width = '250px',
  backgroundColor = palette.secondary.main,
  ...baseProps
}: LoadingSkeletonProps) => {
  return (
    <Base
      {...baseProps}
      height={height}
      width={width}
      backgroundColor={backgroundColor}
      className={styles.container}
      border="none"
    >
      <Shimmer shouldShimmer={shouldShimmer} />
    </Base>
  );
};
